import indemnites from '@amo/core/assets/images/AMO_Icons/indemnites.svg';
import { Question } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import _ from 'lodash';
import { Field } from 'redux-form';
import {getTranslation} from "../../../utils/index.js";

export const AssuranceMoto = (props) => {
    const { nextQuestion, data, antecedentsSur3ans, changeValue } = props;

    return (
        <Question asFieldset
            icon={indemnites}
            title={getTranslation('antecedents.motoInsurance.title')}
            subtitle={getTranslation('antecedents.subtitle', {count: antecedentsSur3ans ? 3 : 2})}
            position={'bottom'}
        >
            <div className={'row justify-content-center mt-2'}>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'assure_moto'}
                        value={'1'}
                        label={getTranslation('yes')}
                        onClick={() => {
                            _.get(data, 'firstValeurCrmMoto') &&
                                changeValue(
                                    'DemandeTarif[ListePersonnes][0][ValeurCrmMoto]',
                                    _.get(data, 'firstValeurCrmMoto'),
                                );
                        }}
                    />
                </div>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'assure_moto'}
                        value={'0'}
                        label={getTranslation('no')}
                        onClick={() => {
                            changeValue('DemandeTarif[ListePersonnes][0][ValeurCrmMoto]', '1');
                            changeValue('DemandeTarif[ListePersonnes][0][NbMoisAssuranceMoto]', null);
                        }}
                    />
                </div>
            </div>

            <button
                className={`btn btn-primary btn-arrow mt-4 ${!_.get(data, 'assure_moto') && 'disabled'}`}
                onClick={() => nextQuestion()}
            >
                {getTranslation('continue')}
            </button>
        </Question>
    );
};
